export default "__VITE_ASSET__BcpECdnd__"